import { useEffect, useState } from "react";
import { PositionedSpinner } from "../../../../../../../components/ui/PositionedSpinner";
import { useParams } from "react-router-dom";
import { SingleForm } from "../../../../../../change/forms/singleFormModel/SingleForm_view";
import { ProcessRolesSidebarModel } from "./ProcessRolesSidebar_model";
import { observer } from "mobx-react-lite";

export const ProcessRolesSidebar: React.FC<{ process: FP.Entities.IProjectProcess }> = observer(({ process }) => {
  const { organisationId, projectId } = useParams();
  const [model] = useState(() => new ProcessRolesSidebarModel(+organisationId, +projectId, process));

  useEffect(() => {
    model.onMount();
    return model.onUnmount;
  }, [model]);

  if (model.isLoading) return <PositionedSpinner />;

  return (
    <div className="container-fluid">
      <SingleForm model={model.formModel} />
    </div>
  );
});
